import React, {useMemo} from 'react'

export const usePOAImportColumn = ({country, segments, entities, categories}) => {
  return useMemo(
    () => [
      {
        Header: 'Action',
        accessor: 'Action',
        required: true,
        toValidate: ({value, dependentField}) => {
          if (!['edit', 'add', 'delete'].includes(value?.toLowerCase())) {
            return 'Action does not match the expected value - edit, add, delete'
          }
          return null
        },
      },
      {
        Header: 'Poa Id',
        accessor: 'Poa Id',
        dependentField: 'Action',
        toValidate: ({value, dependentField}) => {
          if (dependentField?.toLowerCase() === 'update' && value === '') {
            return 'Missing Poa Id for update'
          }
          return null // Ensure null return if no validation error
        },
      },
      {
        Header: 'Country',
        accessor: 'Country',
        required: true,
        toValidate: ({value}) => {
          if (value !== country) {
            return `Country does not match the expected value - ${country}`
          }
          return null
        },
      },
      {
        Header: 'Segment',
        accessor: 'Segment',
        required: true,
        toValidate: ({value}) => {
          if (!segments.includes(value)) {
            return `Segment does not match the expected value - ${segments.toString()}`
          }
          return null
        },
      },
      {
        Header: 'Entity',
        accessor: 'Entity',
        required: true,
        toValidate: ({value}) => {
          if (!entities.includes(value)) {
            return `Entity does not match the expected value - ${entities.toString()}`
          }
          return null
        },
      },
      {
        Header: 'Category',
        accessor: 'Category',
        required: true,
        toValidate: ({value}) => {
          if (!categories.includes(value)) {
            return `Category does not match the expected value - ${categories.toString()}`
          }
          return null
        },
      },
      {
        Header: 'Sub Category',
        accessor: 'Sub Category',
      },
      {
        Header: 'Forms to be Signed',
        accessor: 'Forms to be Signed',
      },
      {
        Header: 'Risk Level',
        accessor: 'Risk Level',
      },
      {
        Header: 'Internal Approval Requirement',
        accessor: 'Internal Approval Requirement',
      },
      {
        Header: 'Internal Approval',
        accessor: 'Internal Approval',
      },
      {
        Header: 'Principal',
        accessor: 'Principal',
      },
      {
        Header: 'Agent',
        accessor: 'Agent',
      },
      {
        Header: 'Remarks',
        accessor: 'Remarks',
      },
    ],
    [country, segments, entities, categories] // Dependency array includes all variables
  )
}
